import type { ICellRendererParams } from 'ag-grid-community';
import { Tooltip } from '@mui/material';
import { LuCheck, LuMinus } from 'react-icons/lu';
import type { PriceSeries } from '../../schema';

interface Props extends ICellRendererParams<PriceSeries, boolean> {
  /** Tooltip shown when the flag is on; doubles as the column's semantic label. */
  onLabel: string;
  /** Tooltip shown when the flag is off. */
  offLabel: string;
}

// Generic ✓ / — renderer for the three boolean columns. Tooltip carries the
// per-column semantic so a hover explains what each flag means without
// needing the editor to memorize four similar headers.
export function FlagCell(p: Props) {
  const on = p.value === true;
  return (
    <Tooltip title={on ? p.onLabel : p.offLabel} arrow placement="top">
      <span
        className={[
          'inline-flex h-6 w-6 items-center justify-center self-center rounded-full',
          on
            ? 'bg-success/15 text-success ring-1 ring-inset ring-success/25'
            : 'text-border-strong',
        ].join(' ')}
        aria-label={on ? p.onLabel : p.offLabel}
      >
        {on ? <LuCheck size={14} strokeWidth={2.5} /> : <LuMinus size={14} />}
      </span>
    </Tooltip>
  );
}
